import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Data Quality dashboard route (`/explorer/data-quality`). Super-admin only
 * (the parent Explorer layout is unguarded, so the guard lives here). Lazy-
 * loaded to stay off the initial authenticated bundle.
 */
const DataQualityPage = lazy(() => import('~/features/explorer/pages/data-quality-page'));

// `connectionId` seeds the selected connection and `sc` the subsidiary scope,
// both from a shared/deep link.
const searchSchema = z.object({
  connectionId: z.string().optional(),
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/data-quality/')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DataQualityPage initialConnectionId={connectionId} />
    </Suspense>
  );
}
